import clsx from "clsx"

import { faIcon } from "@utils/faIcon"

import { ExtraTouchArea } from "@particles/index"

import { Avatar, Divider, Hint, IconButton } from "@atoms"

import styles from "./MobileHeader.module.scss"
import type { MobileHeaderIconButtonProps, MobileHeaderRootProps, MobileHeaderTitleProps } from "./MobileHeader.types"

function MobileHeaderRoot(props: MobileHeaderRootProps & { children?: React.ReactNode }) {
    const { className, children } = props

    return (
        <div className={clsx(styles.base, className)}>
            <div className={styles.innerContainer}>{children}</div>
            <Divider />
        </div>
    )
}

function MobileHeaderTitle(props: MobileHeaderTitleProps) {
    return (
        <div className={clsx(styles.headingWrapper, props.titleClassName)}>
            <div className={styles.titleContainer}>
                {props.avatar && <Avatar {...props.avatar} />}
                <div className={styles.titleAndSupport}>
                    <div className={styles.title}>
                        {props.title}
                        {props.counter && <div className={styles.counter}>{props.counter}</div>}
                        {props.hint && <Hint {...props.hint} />}
                    </div>
                    {props.supportText && <div className={styles.supportText}>{props.supportText}</div>}
                </div>
            </div>
        </div>
    )
}

function MobileHeaderLeftButton(props: MobileHeaderIconButtonProps) {
    return (
        <ExtraTouchArea extraTouchArea={8}>
            <IconButton
                size="xs"
                variant="ghost"
                className={clsx(styles.iconButton, props.className)}
                isTabbable={Boolean(props.isTabbable)}
                icon={props.icon || faIcon({ name: "arrow-left", style: "regular" })}
                onClick={props.onClick}
                aria-label={props["aria-label"]}
                noDebounce={true}
            />
        </ExtraTouchArea>
    )
}

export default {
    Root: MobileHeaderRoot,
    Title: MobileHeaderTitle,
    LeftButton: MobileHeaderLeftButton,
}
